import React from 'react';
import { ProtectedRoute } from '../components/routing/ProtectedRoute';
import { PublicRoute } from '../components/routing/PublicRoute';
import { ROLES } from '../constants/roles';

// Static Pages
import Home from '../pages/Static/Home/index';
import About from '../pages/Static/About/index';
import Pricing from '../pages/Static/Pricing/index';
import NotFoundPage from '../pages/Static/NotFoundPage/index';
import ErrorBoundaryPage from '../pages/Static/ErrorBoundaryPage/index';
import HowitWorks from '../pages/Static/HowItWorks/index';
import DataPrivacy from '../pages/Static/Data/index';
import Scenarios from '../pages/Static/Scenarios/index';

// User Pages
import Profile from '../pages/User/Profile/index';
import Login from '../pages/User/Login/index';
import Register from '../pages/User/Register/index';
import ResetPassword from '../pages/User/ResetPassword/index';
import ConfirmRegistration from '../pages/User/ConfirmRegistration/index';

// Admin Pages
import Admin from '../pages/Admin/Admin/index';

// Application Pages
import Application from '../pages/Application/Application/index';
import ApplicationDemo from '../pages/Application/ApplicationDemo/index';
import ApplicationChat from '../pages/Application/ApplicationChat/index';
import CVConverter from '../pages/Application/Application/index';

export const routes = [
  // Public Routes (No Authentication Required)
  { path: '/', element: <Home /> },
  { path: '/Home', element: <Home /> },
  { path: '/About', element: <About /> },
  { path: '/Pricing', element: <Pricing /> },
  { path: '/How-It-Works', element: <HowitWorks /> },
  { path: '/DataPrivacy', element: <DataPrivacy /> },
  { path: '/Scenarios', element: <Scenarios /> },
  { path: '/error', element: <ErrorBoundaryPage /> },
  
  // Authentication Routes (Redirect if authenticated)
  { 
    path: '/login', 
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    )
  },
  { 
    path: '/register', 
    element: (
      <PublicRoute>
        <Register />
      </PublicRoute>
    )
  },
  { 
    path: '/reset-password', 
    element: (
      <PublicRoute>
        <ResetPassword />
      </PublicRoute>
    )
  },
  {
    path: '/confirm-email',
    element: <ConfirmRegistration />
  },
  {
    path: '/confirm-registration',
    element: <ConfirmRegistration />
  },

  // Protected Routes (Authentication Required)
  { 
    path: '/profile', 
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    )
  },
  { 
    path: '/Application', 
    element: (
      <ProtectedRoute>
        <Application />
      </ProtectedRoute>
    )
  },
  { 
    path: '/Application/Demo', 
    element: (
      <ProtectedRoute requiredRole={ROLES.ADMIN}>
        <ApplicationDemo />
      </ProtectedRoute>
    )
  },
  { 
    path: '/Application/Chat', 
    element: (
      <ProtectedRoute requiredRole={ROLES.ADMIN}>
        <ApplicationChat />
      </ProtectedRoute>
    )
  },

  // Admin Routes
  { 
    path: '/admin', 
    element: (
      <ProtectedRoute requiredRole={ROLES.ADMIN}>
        <Admin />
      </ProtectedRoute>
    )
  },

  // CV Converter (main application route)
  { 
    path: '/cv-converter', 
    element: (
      <ProtectedRoute>
        <CVConverter />
      </ProtectedRoute>
    )
  },

  // 404 Route
  { path: '*', element: <NotFoundPage /> }
];

// Route config for easier management
export const routeConfig = {
  public: ['/Home', '/About', '/Pricing', '/How-It-Works', '/DataPrivacy', '/Scenarios'],
  auth: ['/login', '/register', '/reset-password', '/confirm-email', '/confirm-registration'],
  protected: ['/profile', '/Application', '/cv-converter'],
  admin: ['/admin', '/Application/Demo', '/Application/Chat'],
};

// Helper function to check if route needs authentication
export const requiresAuth = (path) => {
  return routeConfig.protected.includes(path) || routeConfig.admin.includes(path);
};

// Helper function to check if route is admin only
export const isAdminRoute = (path) => {
  return routeConfig.admin.includes(path);
};

// Helper function to check if route is public only
export const isPublicRoute = (path) => {
  return routeConfig.public.includes(path);
};

// Helper function to get redirect path after login
export const getLoginRedirect = (path) => {
  if (!path || isPublicRoute(path)) return '/';
  return path;
};
